(function () {
    var AUTOPLAY_INTERVAL_MS = 6000;

    document.querySelectorAll('.home-must-read-carousel').forEach(function (carousel) {
        const track = carousel.querySelector('.home-must-read-track');
        const slides = track ? Array.from(track.children) : [];
        const dots = Array.from(carousel.querySelectorAll('.home-must-read-dot'));
        const prevBtn = carousel.querySelector('.home-must-read-prev');
        const nextBtn = carousel.querySelector('.home-must-read-next');
        const controls = carousel.querySelector('.home-must-read-controls');

        if (!track || slides.length < 2) {
            if (controls) controls.hidden = true;
            return;
        }

        let activeIndex = 0;
        let autoplayTimer = null;

        const setActive = function (index) {
            activeIndex = index;
            dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === index);
            });
        };

        // Loops in both directions -- past the last slide wraps to the
        // first, and back past the first wraps to the last -- so prev/next
        // never need a disabled state.
        const scrollToIndex = function (index) {
            const looped = (index + slides.length) % slides.length;
            track.scrollTo({left: looped * track.clientWidth, behavior: 'smooth'});
        };

        const goNext = function () {
            scrollToIndex(activeIndex + 1);
        };

        const stopAutoplay = function () {
            if (autoplayTimer) {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
            }
        };

        const startAutoplay = function () {
            stopAutoplay();
            // Respect the OS-level "reduce motion" preference -- an
            // automatically-scrolling carousel is exactly the kind of
            // motion that setting asks sites to avoid.
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                return;
            }
            autoplayTimer = setInterval(goNext, AUTOPLAY_INTERVAL_MS);
        };

        const restartAutoplay = function () {
            stopAutoplay();
            startAutoplay();
        };

        prevBtn.addEventListener('click', function () {
            scrollToIndex(activeIndex - 1);
            restartAutoplay();
        });

        nextBtn.addEventListener('click', function () {
            goNext();
            restartAutoplay();
        });

        dots.forEach(function (dot, i) {
            dot.addEventListener('click', function () {
                scrollToIndex(i);
                restartAutoplay();
            });
        });

        // Pause while the user is actually looking at/interacting with the
        // carousel (hover, keyboard focus) or the tab isn't visible, rather
        // than fighting them or burning cycles in the background.
        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', startAutoplay);
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                stopAutoplay();
            } else {
                startAutoplay();
            }
        });

        // Keeps the active dot in sync with whichever slide is actually in
        // view, including native touch-swipe scrolling (scroll-snap lets
        // that work with zero extra JS) -- not just clicks on the controls
        // or the autoplay timer.
        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                    setActive(slides.indexOf(entry.target));
                }
            });
        }, {root: track, threshold: [0.6]});

        slides.forEach(function (slide) {
            observer.observe(slide);
        });

        setActive(0);
        startAutoplay();
    });
})();
